import {useState} from 'react';

import Input from '@/components/Input';
import {TITLE_MAX_LENGTH} from '@/constants/document/title';

import styles from './index.module.scss';

interface IProps {
    text: string;
    onBlur: (value: string) => void;
}

const NodeInput: React.FC<IProps> = ({text, onBlur}) => {
    const [value, setValue] = useState<string>(text);

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        setValue(e.target.value);
    }
    function handleBlur() {
        onBlur(value);
    }
    return (
        <Input
            autoFocus
            value={value}
            className={styles.input}
            onBlur={handleBlur}
            onPressEnter={handleBlur}
            onChange={handleChange}
            maxLength={TITLE_MAX_LENGTH}
        />
    );
};

export default NodeInput;
